"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleHelmet = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_helmet_1 = __importDefault(require("react-helmet"));
var TitleHelmet = function TitleHelmet(_a) {
    var title = _a.title;
    return (0, jsx_runtime_1.jsx)(react_helmet_1.default, { title: title ? "".concat(title, " - VRChat Profile") : "VRChat Profile" });
};
exports.TitleHelmet = TitleHelmet;
